/* „Przypisz ankietę". The frame, head, acts and refusal are `shared/ui/formDialog`'s and the rows
 * `shared/ui/choiceRow`'s; what stands here is the reserve that keeps the answer from moving
 * anything, the square tick of a multi-select row, the create act, and the quieter ink of a row the
 * backend would refuse. Doubled classes win over `choiceRow` regardless of chunk order. */

.set {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  min-width: 0;
  margin: var(--space-0);
  padding: var(--space-0);
  border: 0;
}

.divider {
  margin: var(--space-2) var(--space-0) var(--space-0);
  padding: var(--space-0);
}

/* „Utwórz nową ankietę": a choice row's shape without the mark, leading to the editor. */
.create.create {
  grid-template-columns: 1fr auto;
  width: 100%;
  font: inherit;
  color: inherit;
  text-align: start;
  background: transparent;
  border: var(--border-hairline) solid var(--border);
}

.create:focus-visible {
  outline: var(--border-focus) solid var(--text);
  outline-offset: var(--space-1px);
}

.createGlyph {
  width: var(--space-14px);
  height: var(--space-14px);
  color: var(--text-2);
}

/* A checkbox is a square: the radio's circle and dot would promise "one of". */
.tick.tick {
  display: grid;
  place-items: center;
  border-radius: var(--radius-4px);
}

/* Ticked: a filled square, out-ranking the chosen row's radio dot (`.rowSelected .rowMark`). */
.tickOn.tickOn.tickOn {
  background: var(--accent);
  border-color: var(--accent);
}

.tickGlyph {
  width: var(--space-10px);
  height: var(--space-10px);
  color: var(--on-accent);
}

/* Five rows' room in every state, scrolled inside past that. */
.list {
  height: calc(5 * var(--h-assign-row));
  overflow-y: auto;
  overscroll-behavior: contain;
}

.state {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  align-items: flex-start;
  justify-content: center;
  height: 100%;
  font-size: var(--fs-note);
  font-weight: var(--fw-medium);
  color: var(--text-2);
}

/* Quieter INK, never an opacity: the badge on the row is a reason to be read. Two classes, because
 * `choiceRow`'s `.row` declares the cursor too and chunk order would otherwise settle it. */
.refused.refused {
  cursor: not-allowed;
}

.refusedTitle {
  font-size: var(--fs-button-sm);
  font-weight: var(--fw-bold);
  color: var(--text-2);
}

.barMark {
  width: var(--space-14px);
  height: var(--space-14px);
  border-radius: var(--r-pill);
}

.barText {
  width: 60%;
  height: var(--space-3);
}
